import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import { Divider } from 'app/components/common';

import './styles.less';

export const CourseSection = ( props ) => {

    const rootClasses = classnames(
        'course-section',
        { 'animate': Boolean( props.animate ) },
        { [ props.className ]: Boolean( props.className ) },
    );

    return (
        <div className={ rootClasses } style={ props.style }>
            { ( props.topDivider ) &&
                <Divider className="course-section-divider" />
            }
            { props.header &&
                <div className="course-section-header">
                    { props.header }
                </div>
            }
            <div className="course-section-content">
                { props.children }
            </div>
        </div>
    );
};


CourseSection.defaultProps = {
    className: undefined,
    style: undefined,
    
    id: undefined,
    header: undefined,
    animate: false,
    topDivider: true,
    // ...
};

CourseSection.propTypes = {
    className: PropTypes.string,
    style: PropTypes.object,
    
    header: PropTypes.oneOfType( [ PropTypes.string, PropTypes.node ] ),
    animate: PropTypes.bool,
    topDivider: PropTypes.bool,
    // ...
};
